import { Link } from "react-router-dom";
import type { AnimeNews } from "@/types";
import Tag from "@/components/base/Tag";

interface NewsCardProps {
  news: AnimeNews;
  variant?: "list" | "compact";
}

const categoryTone: Record<string, "primary" | "secondary" | "accent"> = {
  新闻: "primary",
  专题: "secondary",
  评论: "accent"
};

export default function NewsCard({ news, variant = "list" }: NewsCardProps) {
  if (variant === "compact") {
    return (
      <Link
        to={`/news/${news.id}`}
        className="group flex gap-3 rounded-lg p-2 transition-colors hover:bg-background-100"
      >
        <div className="h-16 w-24 shrink-0 overflow-hidden rounded-md bg-background-100">
          <img
            src={news.thumbnail}
            alt={`${news.title} 资讯配图`}
            title={`${news.title} - 萝莉动漫资讯`}
            className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="min-w-0">
          <h4 className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
            {news.title}
          </h4>
          <p className="mt-1.5 text-xs text-foreground-500">{news.date}</p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${news.id}`}
      className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-all duration-300 hover:border-primary-200 hover:bg-background-100/60 sm:flex-row"
    >
      <div className="h-44 w-full shrink-0 overflow-hidden rounded-md bg-background-100 sm:h-32 sm:w-52">
        <img
          src={news.thumbnail}
          alt={`${news.title} 资讯配图`}
          title={`${news.title} - 萝莉动漫资讯`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="mb-2 flex items-center gap-2">
          <Tag tone={categoryTone[news.category] ?? "secondary"}>{news.category}</Tag>
          <span className="text-xs text-foreground-500">{news.date}</span>
        </div>
        <h3 className="font-heading text-base leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
          {news.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {news.summary}
        </p>
        <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {news.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {news.views.toLocaleString()}
          </span>
        </div>
      </div>
    </Link>
  );
}